/**
 * Single source of truth for "return-to-homepage" state used when a subpage
 * (currently: /residential) needs to send the user back to the exact
 * homepage scroll position they came from.
 *
 * Persisted in sessionStorage so it survives navigation, reload, and BFCache.
 * Consumed once on homepage mount and then cleared.
 */

const KEY = 'sunfield.homeReturn.v1';

export type HomeReturnState = {
  pathname: '/';
  scrollY: number;
  section: string | null;
  savedAt: number;
};

export function saveHomeReturn(scrollY: number, section: string | null) {
  try {
    const payload: HomeReturnState = {
      pathname: '/',
      scrollY,
      section,
      savedAt: Date.now(),
    };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function readHomeReturn(): HomeReturnState | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as HomeReturnState;
    if (!parsed || typeof parsed.scrollY !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearHomeReturn() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}